import React from 'react';
import { Loader2 } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';

// Scrollable checklist of menus (name, alias, status). Shared by the new-campaign and add-menus dialogs.
export default function MenuChecklist({ menus, loading, selected, onToggle, emptyText, testIdPrefix }) {
  return (
    <div className="max-h-64 overflow-y-auto border border-[#27272A] rounded-lg divide-y divide-[#27272A]">
      {loading ? (
        <div className="flex justify-center py-6">
          <Loader2 className="w-5 h-5 animate-spin text-[#52525B]" />
        </div>
      ) : menus.length === 0 ? (
        <p className="text-sm text-[#A1A1AA] p-4 text-center">{emptyText}</p>
      ) : (
        menus.map((m) => (
          <label
            key={m.id}
            className="flex items-center gap-3 px-3 py-2.5 cursor-pointer hover:bg-white/5"
            data-testid={`${testIdPrefix}-${m.id}`}
          >
            <Checkbox checked={!!selected[m.id]} onCheckedChange={() => onToggle(m.id)} />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">{m.name}</p>
              {m.richMenuAliasId ? (
                <p className="text-xs font-mono text-[#A1A1AA] truncate">{m.richMenuAliasId}</p>
              ) : (
                <span className="text-xs text-red-400">no alias</span>
              )}
            </div>
            <span className="text-xs text-[#52525B] capitalize">{m.status}</span>
          </label>
        ))
      )}
    </div>
  );
}
